module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_c('p', {
    staticClass: "copy"
  }, [_vm._v("Copyright ©2019 by Pallavi Dhawan, Devi S. Laskar, and Tamika Thompson")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("“The Face Reader” ©2018 by Bhaskar Caduveti Rao. An earlier version was published in the Sunflower Collective blog ("), _c('a', {
    attrs: {
      "href": "http://sunflowercollective.blogspot.com",
      "target": "_blank"
    }
  }, [_vm._v("sunflowercollective.blogspot.com")]), _vm._v(") on May 27, 2018 under a Creative Commons Attribution 4.0 International License ("), _c('a', {
    attrs: {
      "href": "http://creativecommons.org/licenses/by/4.0",
      "target": "_blank"
    }
  }, [_vm._v("creativecommons.org/licenses/by/4.0")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("“Cut A Hand From A Hand,” “may we all refuse to die at the same time,” and “Channels to fall asleep to” ©2017 by Tongo Eisen-Martin. Earlier versions of these poems were originally published in Heaven Is All Goodbyes (Pocket Poets No. 61, City Lights Books, 2017) and are reprinted by permission of City Lights Books ("), _c('a', {
    attrs: {
      "href": "http://www.citylights.com",
      "target": "_blank"
    }
  }, [_vm._v("www.citylights.com")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("“While looking at photo albums” ©2019 by Kay Ulanday Barrett. This poem was originally published in Poem-a-Day on January 8, 2019 and is reprinted by permission of the poet and the American Academy of Poets ("), _c('a', {
    attrs: {
      "href": "http://www.poets.org",
      "target": "_blank"
    }
  }, [_vm._v("www.poets.org")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("All rights reserved. This book, or parts thereof, must not be reproduced in any form or by any means, electronic or mechanical, including photocopying and recording, or by an information storage and retrieval system, without written permission from the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Aunt Lute Books")]), _vm._v(" "), _c('table', {
    staticClass: "copy0"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("P.O. Box 410687")]), _vm._v(" "), _c('td', {
    staticClass: "right"
  }, [_vm._v("Print ISBN 978-1-879960-98-5")])]), _c('tr', [_c('td', [_vm._v("San Francisco, CA 94141"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.auntlute.com",
      "target": "_blank"
    }
  }, [_vm._v("www.auntlute.com")])]), _vm._v(" "), _c('td', {
    staticClass: "right"
  }, [_vm._v("Ebook ISBN 978-1-939904-34-8")])])])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Cover design: Poonam Whabi")]), _vm._v(" "), _c('p', {
    staticClass: "copy0"
  }, [_vm._v("Book design and typesetting: A.S. Ikeda")]), _vm._v(" "), _c('p', {
    staticClass: "copy0"
  }, [_vm._v("Senior Editor: Joan Pinkvoss")]), _vm._v(" "), _c('p', {
    staticClass: "copy0"
  }, [_vm._v("Artistic Director: Shay Brawn")]), _vm._v(" "), _c('p', {
    staticClass: "copy0"
  }, [_vm._v("Managing Editor: A.S. Ikeda")]), _vm._v(" "), _c('p', {
    staticClass: "copy0"
  }, [_vm._v("Production: Maya Sisneros, María Mínguez Arias, Kayla Rogers, Andrenne Harbin, and Cindy Ho")]), _vm._v(" "), _c('table', {
    staticClass: "copy1"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Publication of this book was made possible, in part, by support from the San Francisco Arts Commission, the National Endowment for the Arts, and the Sara and Two C-Dogs Foundation.")]), _vm._v(" "), _c('td', {
    staticClass: "center1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/4_img01.jpg"
    }
  })])])])]), _vm._v(" "), _c('p', {
    staticClass: "copyh1"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copyh1"
  }, [_vm._v("Names: Dhawan, Pallavi, editor. | Laskar, Devi S., editor. | Thompson, Tamika, editor.")]), _vm._v(" "), _c('p', {
    staticClass: "copyh"
  }, [_vm._v("Title: Graffiti / edited by Pallavi Dhawan, Devi S. Laskar, and Tamika Thompson.")]), _vm._v(" "), _c('p', {
    staticClass: "copyh"
  }, [_vm._v("Description: San Francisco, CA : Aunt Lute Books, [2019] | Summary: “Graffiti is the first installment in a themed, multi-genre anthology series called POC United. The aim of the POC United series is to foster literary spaces in which the work is drawn by forces other than the interests of the white imagination-interests that so often send writers of color down the path of centering oppression for exoticized consumption. In her introduction to the anthology, author and poet Elmaz Abinader says: “Graffiti hits like a playlist of street grinds, jigsaw puzzles, fairy tales and lyric dreams. ... Slashed on the wall of our literature, seeing it close in its moving colors and from afar in its searing declarations, Graffiti gives us just a taste of what writers of color do, unbound.””-- Provided by publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copyh"
  }, [_vm._v("Identifiers: LCCN 2019026261 (print) | LCCN 2019026262 (ebook) | ISBN 9781879960985 (paperback) | ISBN 9781939904348 (ebook)")]), _vm._v(" "), _c('p', {
    staticClass: "copyh"
  }, [_vm._v("Subjects: LCSH: American literature--Minority authors. | Racially mixed people--Literary collections. | Ethnic groups--United States--Literary collections.")]), _vm._v(" "), _c('p', {
    staticClass: "copyh"
  }, [_vm._v("Classification: LCC PS508.M54 G73 2019 (print) | LCC PS508.M54 (ebook) | DDC 810.8/0920693--dc23")]), _vm._v(" "), _c('p', {
    staticClass: "copyh"
  }, [_vm._v("LC record available at "), _c('a', {
    attrs: {
      "href": "https://lccn.loc.gov/2019026261",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/2019026261")])]), _vm._v(" "), _c('p', {
    staticClass: "copyh"
  }, [_vm._v("LC ebook record available at "), _c('a', {
    attrs: {
      "href": "https://lccn.loc.gov/2019026262",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/2019026262")])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Printed in the U.S.A. on acid-free paper")]), _vm._v(" "), _c('p', {
    staticClass: "copy0"
  }, [_vm._v("10 9 8 7 6 5 4 3 2 1")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54e359cb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/copy.vue
// module id = 60
// module chunks = 0